module.exports = __webpack_public_path__ + "static/img/jss-bg.dece70b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/jss-bg.png
// module id = QHJg
// module chunks = 96